import React, { forwardRef, useImperativeHandle, useRef, useState, useMemo } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import {
  convertCstDataIntoTableCompatibleData
} from '../../../../../../utils/transformChartsAndTableData';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { handleHighChartsExport } from '../../../MultiSeriesLineChart/utils';
import { useTranFormReviewRatingChartOption } from '../../../../hooks/useTranFormReviewRatingChartOption';
import get from 'lodash/get';
import GraphTableView from './GraphTableView';
import TableView from './TableView';
import BarGraphView from './BarGraphView';
import { REVIEW_RATING_BY_SITE_OPTIONS } from '../../../../constants';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import LowerSampleSizeFooter from '../../../../../../components/Common/LowerSampleSizeFooter';

const ReviewRatings = forwardRef((props, ref) => {

  const { item, timeperiodLabel } = props;
  const itemData = item;
  const lowSampleSize = get(item, 'lowSampleSize');

  const ALLOWED_COLUMNS = ['Social Media Source', 'No of records', 'Overall Score', '% of Reviews', '#'];
  const DEFAULT_COLOR = '#00008B';

  const [selectedMetrix, setSelectedMetrix] = useState(get(REVIEW_RATING_BY_SITE_OPTIONS, "[0].value", null));
  const chartRef = useRef(null);

  const bar_chart_default_option = get(itemData, "bar_chart_default_option", {});
  const chart_options = get(itemData, "table_graph_default_options");

  const actionButtonClick = (e) => {
    handleHighChartsExport(e, chartRef, itemData);
  };

  useImperativeHandle(ref, () => ({ actionButtonClick }));

  const cstData = get(itemData, 'cstData');

  const tableData = useMemo(() =>
    convertCstDataIntoTableCompatibleData(cstData || {}, ALLOWED_COLUMNS, "Social Media Source"),
    [cstData]
  );

  const graphTableData = useMemo(() =>
    convertCstDataIntoTableCompatibleData(cstData || {}, null, "Social Media Source"),
    [cstData]
  );
  const isPercent = selectedMetrix === '% of Reviews';

  const barChartData = useTranFormReviewRatingChartOption(
    bar_chart_default_option,
    isPercent ? '%' : '',
    selectedMetrix,
    cstData
  );

  const color = get(chart_options, 'plotOptions.series.color', DEFAULT_COLOR);

  if (!cstData) {
    return <GenericNoData />;
  }

  const renderContent = (activeSwitch) => {
    switch (activeSwitch) {
      case 'BAR':
        return (
          <BarGraphView
            selectedMetrix={selectedMetrix}
            setSelectedMetrix={setSelectedMetrix}
            barChartData={barChartData}
            color={color}
            chartRef={chartRef}
          />
        );
      case 'TIME':
        return <GraphTableView graphTableData={graphTableData} chartOptions={chart_options} />;
      case 'TABLE':
        return <TableView tableData={tableData} lowSampleSize={lowSampleSize} />;
      default:
        return null;
    }
  };

  return (
    <MultiFeatureCard
      title={item?.title}
      subTitle={timeperiodLabel}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableActionBtn={item?.enableActionBtn}
      enableSwitchTab={item?.enableSwitchTab}
      switchOptions={item?.switchOptions}
      renderContent={renderContent}
      renderFooter={() => <LowerSampleSizeFooter size={get(item, 'lowSampleSize')} />}
    />
  );
});

export default ReviewRatings;
